// Use code 11 for all services until real coded is confirmed
module.exports = {
    ACCOUNT_CHANGE_RECEIPT: 150,
    AUTHORIZE_BIZUM: 106,
    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER: 220,
    CANCEL_BIZUM: 107,
    CANCEL_CARD_PAY_LATER_ID: 121,
    CARD_ACTIVATION_ID_CC: 221,
    CARD_DEPOSIT_MONEY_ID_CC: 75,
    CARD_PIN_RESET: 207,
    CARD_REQUEST_ADDITIONAL: 203,
    CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT: 103,
    CONTRACT_VIAT: 216,
    DEPOSIT_CHANGE_ACCOUNT: 211,
    EARLY_IMPOSITION_CANCEL: 210,
    GAP_OPERATION_ID: 999,
    IMPOSITION_INTEREST_RENEWAL: 209,
    MODIFY_COMMERCE_AND_ATM_LIMITS: 183,
    MODIFY_MAIN_PHONE: 184,
    SEND_EXTRACTS_VIA_MAIL: 999,
    UPDATE_CLIENT_CONTACT_TIME: 4,
    DEPOSIT_RENOVATION_CANCEL: 257
}
